import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex gap-2 flex-row flex-wrap card-container blue-container" }
const _hoisted_2 = { class: "align-items-center justify-content-center" }
const _hoisted_3 = { class: "align-items-center justify-content-center" }
const _hoisted_4 = { class: "align-items-center justify-content-center" }
const _hoisted_5 = { for: "writers" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "align-items-center justify-content-center" }
const _hoisted_9 = { class: "align-items-center justify-content-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)

import Button from 'primevue/button'
import Message from 'primevue/message'
import Panel from 'primevue/panel'
import AutoComplete, {AutoCompleteCompleteEvent} from 'primevue/autocomplete'

import {AxiosStatic} from "axios";
import {inject, onMounted, reactive, ref} from "vue";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import GemProjectField from "@/components/blocks/GemProjectField.vue";
import InputField from "@/components/blocks/InputField.vue";

import {GemProject} from "@/components/blocks/Types";

// Define types
type FormData = {
  rootProject: GemProject | null,
  project: GemProject | null,
  tag: GemProject | null,
  pattern: string | null,
  description: string | null,
  writers: Array<string> | null
}

// Define component data

export default /*#__PURE__*/_defineComponent({
  __name: 'RemoteWritersForm',
  emits: ['itemCreated'],
  setup(__props, { emit: emits }) {

const formData = reactive<FormData>({
  rootProject: null,
  project: null,
  tag: null,
  pattern: null,
  description: null,
  writers: []
})

const formRef = ref(null)
const submitted = ref<boolean>(false)
const fromTimeSent = ref<Date>(new Date())
const errorMessage = ref<string | null>(null)
const writerTypes = ref()
const filteredTypes = ref()


const rules = {
  rootProject: {required},
  project: {required},
  tag: {},
  pattern: {required},
  description: {required},
  writers: {required, minLength: 1}
}

// Inject dependencies
const axios = inject<AxiosStatic>('axios')

// Define used properties
const router = useRouter()
const v$ = useVuelidate(rules, formData)

// Define emits


// Define lifecycle hooks
onMounted(() => {
  axios?.get("/remote-writer/types")
      .then(response => {
        if (response.status >= 200 && response.status <= 299) {
          writerTypes.value = response.data
        } else {
          console.error('Can not load remote writers types')
        }
      })
})

// Define functions
function filterWriter(event: AutoCompleteCompleteEvent) {
  if (!event.query.trim().length) {
    filteredTypes.value = [...writerTypes.value]
  } else {
    filteredTypes.value = writerTypes.value.filter((writer: string) => {
      return writer.toLowerCase().startsWith(event.query.toLowerCase());
    });
  }
}

function handleSubmit(isFormValid: boolean) {
  submitted.value = true
  if (isFormValid) {
    saveSettings()
  } else {
    console.error('Form is not valid!', v$)
  }
}

function saveSettings() {
  const path = "/remote-writer"
  errorMessage.value = null
  axios?.post(path, buildData()).then((response) => {
    if (response.status >= 200 && response.status <= 299) {
      if (response.data.id > 0) {
        emits('itemCreated', response.data)
        submitted.value = false
      } else {

        if (response.data.success == false) {
          // this is custom error response with any business error
          errorMessage.value = response.data.list[0].message
        }
      }
    } else {
      console.error(response)
    }
  })
}

function buildData(): any {
  const x = {
    projectRootId: formData.rootProject?.id,
    projectId: formData.project?.id,
    keyPattern: formData.pattern,
    remoteWriterList: formData.writers?.join(";"),
    tagId: formData.tag?.id,
    description: formData.description
  }
  return x
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), { class: "mt-2 mb-2" }, {
    default: _withCtx(() => [
      (errorMessage.value!=null)
        ? (_openBlock(), _createBlock(_unref(Message), {
            key: 0,
            severity: "error",
            closable: false
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(GemProjectField, {
              vualidate: _unref(v$),
              submitted: submitted.value,
              rootProject: _unref(v$).rootProject.$model,
              "onUpdate:rootProject": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).rootProject.$model) = $event)),
              project: _unref(v$).project.$model,
              "onUpdate:project": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).project.$model) = $event)),
              tag: _unref(v$).tag.$model,
              "onUpdate:tag": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).tag.$model) = $event))
            }, null, 8, ["vualidate", "submitted", "rootProject", "project", "tag"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(InputField, {
              id: "pattern",
              label: "Pattern",
              vualidate: _unref(v$).pattern,
              submitted: submitted.value,
              modelValue: formData.pattern,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.pattern) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              _createTextVNode("Writers "),
              (_unref(v$).writers.required)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "*"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(AutoComplete), {
              id: "writers",
              modelValue: _unref(v$).writers.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).writers.$model) = $event)),
              multiple: true,
              onComplete: _cache[5] || (_cache[5] = ($event: any) => (filterWriter($event))),
              class: _normalizeClass({'p-invalid':_unref(v$).writers.$invalid && submitted.value}),
              dropdown: true,
              suggestions: filteredTypes.value
            }, null, 8, ["modelValue", "class", "suggestions"]),
            (_unref(v$).writers.$invalid && submitted.value)
              ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_unref(v$).writers.required.$message.replace('Value', 'Writers')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(InputField, {
              id: "description",
              label: "Description",
              vualidate: _unref(v$).description,
              submitted: submitted.value,
              modelValue: _unref(v$).description.$model,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).description.$model) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_unref(Button), {
              type: "submit",
              label: "Add"
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})